module.exports = __webpack_public_path__ + "static/img/COC2023-19.c52922c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-19.png
// module id = MW1i
// module chunks = 0